
import Vue from "vue";
import {Component} from "vue-property-decorator";
import Modal from "../UI/Modal.vue";

@Component({
    components: {
        Modal
    }
})
export default class AccessibilityGuide extends Vue {
    close() {
        this.$emit('close');
    }
}
